class RcProductInventory extends HTMLElement {

  constructor() {
    super();
    this.event;
    this.currentVariant;
    this.textTemplates = {};
  };
    
  connectedCallback() { this.initialize(); };

  disconnectedCallback() { this.deinitialize(); };

  updateInventoryStatus(variant) {
    if(!variant) return;
    const isAvailable = variant.available !== false;
    const inventoryPolicy = variant.inventory_policy || 'deny';
    const quantity = variant.inventory_quantity ?? 0;
    let status = 'out_of_stock';
    let qtyForText = null;

    if(isAvailable) {
      if(quantity > 0) {
        const { criticalStockThreshold, lowStockThreshold } = window.umbrellaConfig.inventory;
        if(quantity <= criticalStockThreshold) {
          status = 'critical';
        } else if (quantity <= lowStockThreshold) {
          status = 'low';
        } else {
          status = 'available';
        };
        if(status !== 'available') qtyForText = quantity;
      } else if (inventoryPolicy === 'continue') {
        status = 'available';
      }
    };

    this.updateInventoryText(status, qtyForText);
    this.updateInventoryIndicator(status);
  };

  updateInventoryText(status, quantity) {
    const templateText = this.textTemplates[status] || '';
    const statusText = this.querySelector('[data-inventory-status-text]');
    if(!statusText) return;
    let text = templateText != null ? templateText : statusText.innerText || '';
    if(quantity !== null && quantity !== undefined) {
      const qty = String(quantity);
      if(/\{\{\s*quantity\s*\}\}/.test(text)) {
        text = text.replace(/\{\{\s*quantity\s*\}\}/g, qty);
      } else if (/\{quantity\}/.test(text)) {
        text = text.replace(/\{quantity\}/g, qty);
      } else if (/%\{quantity\}/.test(text)) {
        text = text.replace(/%\{quantity\}/g, qty);
      } else {
        text = text.replace(/\d+/g, qty);
      }
    } else {
      text = text
        .replace(/\{\{\s*quantity\s*\}\}/g, '')
        .replace(/\{quantity\}/g, '')
        .replace(/%\{quantity\}/g, '');
    };
    statusText.innerText = text.trim();
  };

  updateInventoryIndicator(status) {
   this.setAttribute('data-available', status);
  };

  onVariantChange = (event) => {
    const variant = event.detail && event.detail.data;
    if(!variant) return;
    this.currentVariant = variant;
    this.updateInventoryStatus(variant);
  };

  initialize() {
    this.event = window.umbrellaConfig.events.variantChange;
    this.textTemplates = window.umbrellaConfig?.inventory?.text || {};
    document.addEventListener(this.event, this.onVariantChange);
  };
    
  deinitialize() { document.removeEventListener(this.event, this.onVariantChange); };

};

if(!customElements.get('rc-product-inventory')) customElements.define('rc-product-inventory', RcProductInventory);